import { NavLink } from 'react-router-dom';
import './assessmentSubHeader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../tooltip/tooltip';
import content from '../../content/content';

const AssessmentSubHeader = ({ title, subtitle }) => {
    return (
        <div className="assessment-sub-header-wrapper">
            <nav>
                <NavLink to="/assessment/policy" className={({ isActive }) => isActive ? 'active-link' : 'inactive-link'}>Policy<span><Tooltip text={content.categoryDescriptions.policy}><FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon></Tooltip></span></NavLink>
                <NavLink to="/assessment/people" className={({ isActive }) => isActive ? 'active-link' : 'inactive-link'}>People<span><Tooltip text={content.categoryDescriptions.people}><FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon></Tooltip></span></NavLink>
                <NavLink to="/assessment/technology" className={({ isActive }) => isActive ? 'active-link' : 'inactive-link'}>Technology<span><Tooltip text={content.categoryDescriptions.technology}><FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon></Tooltip></span></NavLink>

                <NavLink to="/assessment/opportunities" className={({ isActive }) => isActive ? 'active-link' : 'inactive-link'}>Opportunities </NavLink>
                      
                 </nav>  
        </div>              
    );
};
 
export default AssessmentSubHeader;